import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/pages.css";
import Banner from "../ui/Banner";
import { getListProduct } from "../../api";
import LandingImg from "../ui/LandingImg";
import products from "../../assets/images/products.png";
import golfback from "../../assets/images/golfback2.png";

const EnProductCatalog = ({ category, siblings }) => {
  const navigate = useNavigate();
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const activeTab = category.en_name.toLowerCase();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const data = await getListProduct({ category: activeTab });
        setProductList(data.data.results ?? data.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to load products information.");
        setLoading(false);
      }
    };
    fetchProducts();
  }, [activeTab]);

  const handleTabChange = (tabId) => {
    navigate(`/en/products/${tabId}`);
  };

  // 사업부별 배너 메타 (order 값 기준)
  const bizMeta = {
    1: {
      title: "Agribusiness Dept.",
      description: [
        "The perfect solution for the farm world",
        "Introducing ECOTECH GLOBAL's products completed with proven technology.",
      ],
      backgroundImage: products,
    },
    2: {
      title: "Advanced Materials & Components Dept.",
      description: [
        "Next-generation materials and core component technologies",
        "Providing innovative solutions across diverse industries."
      ],
      backgroundImage: products,
    },
    3: {
      title: "K-Defense Dept.",
      description: [
        "Powered by advanced technologies and innovative solutions",
        "Shaping the future of Korea's defense industry."
      ],
      backgroundImage: products,
    },
  };
  // golf
  const categoryBannerOverrides = {
    golf: {
      title: "Agribusiness Dept.",
      description: ["Innovation in Carbon-Aramid Composite Materials", "Ratel Park Golf Club"],
      backgroundImage: golfback,
    },
  };
  const bizBanner = bizMeta[category.order] || bizMeta[1];
  const override = categoryBannerOverrides[activeTab];

  const bannerConfig = {
    backgroundImage: override?.backgroundImage ?? bizBanner.backgroundImage,
    title: override?.title ?? bizBanner.title,
    description: override?.description ?? bizBanner.description,
    tabs: siblings.map((cat) => ({
      id: cat.en_name.toLowerCase(),
      name: cat.en_name,
    })),
  };

  return (
    <div className="product-container">
      <Banner {...bannerConfig} activeTab={activeTab} onTabChange={handleTabChange} />
      <div className="productarea-section">
        {loading && <div className="loading">Loading...</div>}
        {error && <div className="error">{error}</div>}

        {!loading &&
          productList.map(
            (product) =>
              product.thumbnail && (
                <LandingImg key={product.id} src={product.thumbnail.file.url} />
              )
          )}

        {!loading && productList.length === 0 && (
          <div className="empty">None</div>
        )}
      </div>
    </div>
  );
};

export default EnProductCatalog;
